import React from 'react'
import { connect } from 'react-redux'

import { Header1, Body1 } from 'pharmacy/src/typography'
import { Button } from 'pharmacy/src/input/button'
import { Icon } from 'pharmacy/src/display/icon'
import { Logo } from 'pharmacy/src/style/logo'

import { ONBOARDING_MODAL } from 'mednet-util/src/constants/modal'
import { mixpanel } from 'mednet-util/src/tracking'

import css from './introScreen.scss'

class IntroScreen extends React.Component {
  componentDidMount() {
    mixpanel.track('viewed_onboarding_intro')
  }

  handleContinue = () => {
    this.props.changeModalScreen(ONBOARDING_MODAL.screens.customizeFeed)
  }

  render() {
    return (
      <div className={css.container}>
        <div className={css.logoContainer}>
          <Logo className={css.logo} />
        </div>

        <div className={css.headerWrapper}>
          <div className={css.header}>
            <Header1 className={css.title}>Welcome to Mednet</Header1>
            <Body1 className={css.subtitle}>
              A physician-only platform for expert answers to real-world
              clinical situations.
            </Body1>
          </div>
        </div>

        <div className={css.infoCardsWrapper}>
          <div className={css.infoCards}>
            <div className={css.infoCard}>
              <div className={css.infoCardBody}>
                <div className={css.cardHeader}>
                  <Icon icon={['fas', 'user-md']} className={css.cardIcon} />
                  <h3 className={css.cardTitle}>Ask an expert</h3>
                </div>
                <p className={css.cardDescription}>
                  Post nuanced clinical questions & get input from experts
                  across specialities.
                </p>
              </div>
            </div>

            <div className={css.infoCard}>
              <div className={css.infoCardBody}>
                <div className={css.cardHeader}>
                  <Icon icon={['fas', 'search']} className={css.cardIcon} />
                  <div className={css.cardTitleRow}>
                    <h3 className={css.cardTitle}>Mednet AI</h3>
                    <span className={css.comingSoonBadge}>NEW</span>
                  </div>
                </div>
                <p className={css.cardDescription}>
                  Get instant answers powered by trusted guidelines, FDA data,
                  abstracts & expert Q&A.
                </p>
              </div>
            </div>

            <div className={css.infoCard}>
              <div className={css.infoCardBody}>
                <div className={css.cardHeader}>
                  <Icon icon={['fas', 'comments']} className={css.cardIcon} />
                  <h3 className={css.cardTitle}>Community</h3>
                </div>
                <p className={css.cardDescription}>
                  Compare your practice to your peers
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={css.buttonContainer}>
          <Button className={css.continueButton} onClick={this.handleContinue}>
            Next
          </Button>
        </div>
      </div>
    )
  }
}

export default connect()(IntroScreen)
